<p-datepicker
  [(ngModel)]="rangeDates"
  (ngModelChange)="onRangeDatesChange()"
  selectionMode="range"
  [numberOfMonths]="2"
  [showIcon]="true"
  [minDate]="minDate"
  [maxDate]="maxDate"
  size="small"
  styleClass="w-100"
  [dateFormat]="'dd/mm/yy'"
>
  <ng-template pTemplate="footer">
    <ng-container *ngIf="footerTemplate">
      <ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
    </ng-container>
  </ng-template>
</p-datepicker>
